<div [routerLink]="'/favourites/'+data?.id" [class]="(data?.canonicalStatus || '') | lowercase">

  <nav class="lib-nav">
    <div [hidden]="!data?.canonicalStatus" [class]="'lib-badge '+(data?.canonicalStatus || '') | lowercase" [ngSwitch]="toggle.offerAccepted">
      <span *ngSwitchDefault>{{data?.canonicalStatus | uppercase }}</span>
      <span *ngSwitchCase="true">Offer Accepted</span>
    </div>
    <span class="lib-spacer-fixed"></span>
    <p class="lib-legend" [hidden]="data?.canonicalStatus !== 'Eligible' || !data?.marketValue">Up to
      {{data?.eligibleUpTo | shortNumber}}</p>
    <!-- <div [hidden]="data?.canonicalStatus !== 'Eligible'">
      <span class="lib-legend">MARKET VALUE</span>
      <h6>{{data?.marketValueRange[0] | shortNumber}} - {{data?.marketValueRange[1] | shortNumber}}</h6>
    </div> -->
    <span class="lib-spacer"></span>
    <span class="lib-spacer-fixed"></span>
    <button class="lib-button options">
      <lib-icon name="options"></lib-icon>
    </button>
    <ul class="lib-elevation-1">
      <li>
        <button class="lib-button-primary" type="button" [hidden]="data?.canonicalStatus !== 'Eligible' || toggle.offerAccepted"
          (click)="offerAccepted($event)">
          <lib-icon name="broker"></lib-icon>
          <span>My offer has been accepted</span>
        </button>
        <button class="lib-button-warn" type="button" [hidden]="!toggle.offerAccepted"
          (click)="offerAcceptedRemoved($event)">
          <lib-icon name="broker"></lib-icon>
          <span>Remove offer accepted</span>
        </button>
        <button class="lib-button" type="button" (click)="bookACall($event)" [hidden]="!toggle.qualifiesForBookACall">
          <lib-icon name="support"></lib-icon>
          <span>Talk to our team</span>
        </button>
        <button class="lib-button-warn" type="button" [hidden]="data?.canonicalStatus !== 'Eligible' || toggle.offerAccepted"
          (click)="archiveFavourite($event)">
          <lib-icon name="close"></lib-icon>
          <span>Archive</span>
        </button>
      </li>
    </ul>
  </nav>

  <div>
    <lib-thumbnail [data]="data?.listing" type="liked" [isRecommended]="isRecommended"></lib-thumbnail>
  </div>

</div>
